import React from 'react';
import PropTypes from 'prop-types';

const $ = window.jQuery;

class Modal extends React.PureComponent {
  componentDidMount() {
    $('body').addClass('modal-open');
  }
  componentWillUnmount() {
    $('body').removeClass('modal-open');
  }
  handleClose = () => {
    this.props.onClose();
  }
  render() {
    return (
      <div className="my-modal">
        <div className="bg" onClick={this.handleClose} />
        <div className={`modal-content ${this.props.className}`}>
          <button className="close" onClick={this.handleClose}>close</button>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
};

Modal.defaultProps = {
  onClose: () => {},
  className: '',
};

export default Modal;



// WEBPACK FOOTER //
// ./src/HomePage/blocks/FlavourBlock/Model.js